export const AREAS = [
  { slug: "peterborough", name: "Peterborough", county: "Cambridgeshire" },
  { slug: "oundle", name: "Oundle", county: "Northamptonshire" },
  { slug: "yaxley", name: "Yaxley", county: "Cambridgeshire" },
  { slug: "whittlesey", name: "Whittlesey", county: "Cambridgeshire" },
  { slug: "stamford", name: "Stamford", county: "Lincolnshire" },
  { slug: "market-deeping", name: "Market Deeping", county: "Lincolnshire" },
  { slug: "bourne", name: "Bourne", county: "Lincolnshire" },
  { slug: "ramsey", name: "Ramsey", county: "Cambridgeshire" },
  { slug: "huntingdon", name: "Huntingdon", county: "Cambridgeshire" },
  { slug: "spalding", name: "Spalding", county: "Lincolnshire" },
  { slug: "march", name: "March", county: "Cambridgeshire" },
  { slug: "ely", name: "Ely", county: "Cambridgeshire" },
  { slug: "wisbech", name: "Wisbech", county: "Cambridgeshire" },
];

export const findArea = (slug) => AREAS.find((a) => a.slug === slug);
